<template>
  <ald-loader v-if="!legalText" />
  <div v-else class="container">
    <div v-if="hasCloseButton" class="close-button-container">
      <span :class="{ fixed: btnClosePosFixed }" class="close-button" @click="onClickClose">X</span>
    </div>
    <ald-markdown id="legal-markdown" :content="legalText" only-preview primary />
    <Links />
  </div>
</template>

<script>
import MediaQueriesMixin from 'mixins/MediaQueriesMixin';
import { GET_MARKDOWN_FILE } from 'store/actions/ui';
import LegalWarning from 'documents/LegalWarning.md';
import PrivacyPolicy from 'documents/PrivacyPolicy.md';
import CookiesPolicy from 'documents/CookiesPolicy.md';
import Links from '../../main/Links';

export default {
  components: {
    Links
  },

  mixins: [MediaQueriesMixin],

  data() {
    return {
      legalText: '',
      btnClosePosFixed: false,
      documentType: {
        legal: 'legal',
        privacy: 'privacy',
        cookie: 'cookies'
      },
      documentContent: {
        legal: LegalWarning,
        privacy: PrivacyPolicy,
        cookies: CookiesPolicy
      }
    };
  },

  computed: {
    hasCloseButton() {
      return false;
    }
  },

  watch: {
    $route(to) {
      const { type } = to.params;
      this.legalText = '';
      this.loadLegalContent(type);
    }
  },

  mounted() {
    window.addEventListener('scroll', () => {
      const scrollPosY = window.pageYOffset || document.documentElement.scrollTop;
      const posYCondition = this.mobileAndTabletPortrait ? 56 : 56;
      this.btnClosePosFixed = scrollPosY >= posYCondition;
    });
  },

  created() {
    const { type } = this.$route.params;
    if (['legal', 'privacy', 'cookies'].includes(type)) {
      this.loadLegalContent(type);
    } else {
      this.$router.push({ name: '404' });
    }
  },

  methods: {
    loadLegalContent(type) {
      const file = this.documentContent[type];
      this.$store
        .dispatch(`ui/${GET_MARKDOWN_FILE}`, {
          file,
          field: `legal.${type}`
        })
        .then(
          () => {
            this.legalText = this.$store.getters['ui/dataUI'](`legal.${type}`);
          },
          () => {
            this.legalText = '# ==Ups!== 😔';
          }
        )
        .catch(error => console.log('ERROR_GE_LEGAL:', error));
    },

    onClickClose() {
      // Verificar si se puede hacer back
    }
  },

  metaInfo() {
    const { type } = this.$route.params;
    return {
      title: `${process.env.APP_NAME} | ${this.$i18n.t(`title.${type}`)}`
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 20px;
  padding-bottom: 20px;

  .close-button {
    -moz-box-sizing: content-box;
    -webkit-box-sizing: content-box;
    background: $color-gray;
    border-radius: 50%;
    box-sizing: content-box;
    color: $color-white;
    cursor: pointer;
    display: inline-block;
    font-size: 35px;
    font-weight: bold;
    line-height: 55px;
    margin-left: -55px;
    min-width: 55px;
    opacity: 0.7;
    position: absolute;
    text-align: center;
    z-index: 1;

    &:hover {
      background-color: $color-rich-black;
    }

    &.fixed {
      margin-top: -56px;
      position: fixed;

      @media #{$mobile-ext-device} {
        margin-top: -56px;
      }
    }

    &-container {
      position: relative;
      text-align: right;
      width: inherit;
    }
  }
}
</style>
